var exports = {
  "dw": "BanDetailsModal.module__userSection___aEw0cj",
  "my": "BanDetailsModal.module__avatar___aEw0cj",
  "rZ": "BanDetailsModal.module__avatarPlaceholder___aEw0cj",
  "eF": "BanDetailsModal.module__userInfo___aEw0cj",
  "Xh": "BanDetailsModal.module__username___aEw0cj",
  "Tc": "BanDetailsModal.module__tag___aEw0cj",
  "zH": "BanDetailsModal.module__details___aEw0cj",
  "wV": "BanDetailsModal.module__detailRow___aEw0cj",
  "M": "BanDetailsModal.module__detailLabel___aEw0cj",
  "zL": "BanDetailsModal.module__detailValue___aEw0cj",
  "oc": "BanDetailsModal.module__noReason___aEw0cj",
  "S4": "BanDetailsModal.module__moderator___aEw0cj",
  "Y1": "BanDetailsModal.module__unknownModerator___aEw0cj",
};

module.exports = exports;
